import { css } from 'styled-components';
import { SpacingName } from '../../theme/constants';
import { TypographyName } from '../../theme/typography';
import { getTypography, getSpacing, rgba } from '../../theme/utils';
export const select = _ref => {
  let {
    theme,
    disabled,
    $error
  } = _ref;
  return css(["", " ", " appearance:none;-moz-appearance:none;-webkit-appearance:none;background-color:", ";border:1px solid ", ";box-sizing:border-box;border-radius:.3rem;color:", ";height:3.125rem;line-height:3.125rem;outline:0;width:100%;&::placeholder{color:", ";}&:focus{box-shadow:0px 0 4px ", ";border:1px solid ", ";}", " ", ""], getTypography(theme, TypographyName.BODY), getSpacing.padding(theme, [0, SpacingName.SMALLER]), theme.palettes.neutrals.lightest, theme.palettes.neutrals.medium, theme.palettes.neutrals.darkest, theme.palettes.neutrals.medium, rgba(theme.palettes.neutrals.darkest, 0.3), theme.palettes.neutrals.medium, disabled && `
      background-color: ${rgba(theme.palettes.status.disabled, 0.3)};
      border: 1px solid ${theme.palettes.neutrals.lighter};
      color: ${theme.palettes.neutrals.medium};
      opacity: 1;
      user-select: none;

      &::placeholder {
        color: ${theme.palettes.neutrals.light};
      }
    `, $error && `
      border: 1px solid ${theme.palettes.status.alert};
    `);
};
export const wrapper = () => css(["position:relative;"]);
export const icon = _ref2 => {
  let {
    theme,
    disabled
  } = _ref2;
  return css(["", " align-items:center;background-color:transparent;border:0;border-radius:0 0.5rem 0.5rem 0;bottom:1px;color:", ";display:flex;outline:0;position:absolute;right:1px;top:1px;z-index:1;pointer-events:none;"], getSpacing.paddingRight(theme, SpacingName.SMALLER), disabled ? theme.palettes.neutrals.light : theme.palettes.neutrals.medium);
};
export const loading = _ref3 => {
  let {
    theme
  } = _ref3;
  return css(["", " background-color:", ";display:flex;align-items:center;justify-content:flex-end;position:absolute;top:0;bottom:0;right:0;left:0;"], getSpacing.paddingRight(theme, SpacingName.SMALLER), rgba(theme.palettes.neutrals.lightest, 0.7));
};
//# sourceMappingURL=Select.style.js.map